/**
* カスタムアコーディオン制御システム
* ファイル名: custom-accordion-controller.js
* 配置場所: assets/custom-accordion-controller.js
* 作成者: yama
* 機能: 現在ページ判定、アニメーション、外側クリック閉じ
* 対象: #menuDropdown
* 
* 概要:スマホ用ドロップダウンメニューの動作制御
* <details>と<summary>を使用したアコーディオン形式
*/
console.log("現在のパス:", window.location.pathname);
        // ドロップダウンの初期化設定
        const dropdownOptions = {
            duration: 300,
            easing: "ease-in-out"
        };

        // カスタムドロップダウンの初期化
        const initializeCustomDropdown = (dropdown, options = {}) => {
            if (!dropdown) {
                console.error("initializeCustomDropdown: Dropdown element is not found.");
                return;
            }

            const summary = dropdown.querySelector("summary");
            const content = dropdown.querySelector(".dropdown-content");
            const items = dropdown.querySelectorAll(".dropdown-item");

            if (!summary || !content || !items.length) {
                console.error("initializeCustomDropdown: Required elements are not found.");
                return;
            }

            const mergedOptions = { ...dropdownOptions, ...options };

            // 現在のページを設定
            setCurrentPage(dropdown);

            // アイテムクリック時の処理
            items.forEach(item => {
                item.addEventListener("click", (event) => {
                    dropdown.open = false;
                });
            });

            // 外側クリックで閉じる
            document.addEventListener("click", (event) => {
                if (!dropdown.contains(event.target)) {
                    dropdown.open = false;
                }
            });

            // アニメーション処理
            setupDropdownAnimation(dropdown, content, mergedOptions);
        };

        // 現在のページを設定
        const setCurrentPage = (dropdown) => {
        const currentPath = window.location.pathname;
        const summary = dropdown.querySelector("summary");
        const items = dropdown.querySelectorAll(".dropdown-item");

        // デバッグ用
        console.log("dropdown:", dropdown);
        console.log("summary:", summary);

        let currentItem = null;
            
        items.forEach(item => {
            const itemUrl = item.getAttribute("data-url");
            item.classList.remove("current");
            
            if (itemUrl === currentPath) {
                item.classList.add("current");
                currentItem = item;
            }
        });
        // summaryのテキストを現在のページに更新
        if (currentItem) {
            summary.textContent = currentItem.textContent;
        }
        };

        // 現在のパスを取得（デモ用）
        const getCurrentPath = () => {
            return localStorage.getItem("currentPath") || "/page1";
        };

        // アイテムクリック時の処理
        const handleItemClick = (event, dropdown) => {
            const item = event.target;
            const url = item.getAttribute("data-url");
            const summary = dropdown.querySelector("summary");

            // summaryのテキストを更新
            summary.textContent = item.textContent;
            
            // 現在のページマーカーを更新
            dropdown.querySelectorAll(".dropdown-item").forEach(i => i.classList.remove("current"));
            item.classList.add("current");

            dropdown.open = false;

            localStorage.setItem("currentPath", url);
            document.getElementById("currentPageDisplay").textContent = url;
            
            console.log(`ページ遷移: ${url}`);
        };

        // ドロップダウンアニメーションの設定
        const setupDropdownAnimation = (dropdown, content, options) => {
            const summary = dropdown.querySelector("summary");
            
            summary.addEventListener("click", (event) => {
                event.preventDefault();
                
                if (dropdown.open) {
                    // 閉じるアニメーション
                    const animation = content.animate([
                        { maxHeight: content.scrollHeight + "px", opacity: 1 },
                        { maxHeight: "0px", opacity: 0 }
                    ], {
                        duration: options.duration,
                        easing: options.easing
                    });

                    animation.addEventListener("finish", () => {
                        dropdown.open = false;
                    });
                } else {
                    // 開くアニメーション
                    dropdown.open = true;
                    const startHeight = content.scrollHeight;
                    
                    content.animate([
                        { maxHeight: "0px", opacity: 0 },
                        { maxHeight: startHeight + "px", opacity: 1 }
                    ], {
                        duration: options.duration,
                        easing: options.easing
                    });
                }
            });
        };

        // DOMが読み込まれた後に初期化
        document.addEventListener("DOMContentLoaded", () => {
            const dropdown = document.getElementById("menuDropdown");
            
            if (dropdown) {
                initializeCustomDropdown(dropdown, {
                    duration: 300
                });
            }

            // 初期表示用
            document.getElementById("currentPageDisplay").textContent = getCurrentPath();
        });

        // リサイズ時の処理（必要に応じて）
        window.addEventListener("resize", () => {
            // リサイズ時に必要な処理があればここに追加
        });